import {useEffect, useState, useRef} from 'preact/hooks';
import {resource, cooperation} from '~/locals/qianfan/index';

import arrow from 'assets/qianfan/icon_play_hover.svg';
import ALink from '~/components/base/aLink';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'qfResource';
const moduleTitleClassName = 'qf-module-title';
const moduleDescClassName = 'qf-module-desc';
const moduleContentClassName = 'qf-module-content';

const Resource = () => {
    const {list, title, desc, descLink} = resource;
    useCptDuration(id, {
        name: `${applicationName}-${title}-停留时长`
    });

    return (
        <>
            {/* 合作伙伴 */}
            <div className={`qf-partner ${moduleContentClassName}`}>
                <div className="module-wrapper">
                    <div className="module-container">
                        <div className="partner-title">
                            <div className="gradual-line gradual-left-line"></div>
                            <div className="gradual-title-text no_rem_fs_16">{cooperation.title}</div>
                            <div className="gradual-line gradual-right-line"></div>
                        </div>
                        <ul className="partner-list">
                            {cooperation.list.map(item => {
                                return (
                                    <li className="partner-logo" key={item.id}>
                                        <img src={item.icon} alt="logo" />
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
            {/* 全面的 AI 开发资源 */}
            <div className="qf-resource" id="qfResource">
                <div className="module-wrapper">
                    <div className="module-container">
                        <h2 className={`title ${moduleTitleClassName}`}>{title}</h2>
                        <p className={`module-desc no_rem_fs_16 ${moduleDescClassName}`}>
                            {desc}
                            <a
                                href={descLink.link}
                                target="_blank"
                                className="module-desc-link no_rem_fs_16"
                                rel="noreferrer"
                                {...descLink.trackInfo}
                            >
                                {descLink.text}
                                <img src={arrow} alt="箭头" className="qf-icon" />
                            </a>
                        </p>
                        <div className={`flex-resource ${moduleContentClassName}`}>
                            {list.map(item => (
                                <div className="resource-item" key={item.name}>
                                    <h3 className="resource-title">{item.name}</h3>
                                    <div className="resource-exp-list">
                                        {item.exp.map(i => {
                                            return (
                                                <ALink className="resource-exp no_rem_fs_16" href={i.link} key={i.link}>
                                                    {i.label}
                                                </ALink>
                                            );
                                        })}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Resource;
